module.exports = __webpack_public_path__ + "static/media/sloga-slider-desktop.21dae941.png";